<template>
  <v-layout  column fill-height>         
   <div class="flex !grow-0 flex-wrap items-center">    
     <!-- <div  class="flex-grow-0" style="border:1px solid #ccc;border-bottom: 0px;border-top: 0px;border-left:0px ;">        
       <v-btn v-if="!allMissionVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_SHOW_ALL_SIMULATION_MISSION_MAP();" :title="$t('Pilot.MissionDrawer.ShowAllListedMissionTooltip')" ><v-icon>mdi-eye-off</v-icon></v-btn>  
       <v-btn v-if="allMissionVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_HIDE_ALL_SIMULATION_MISSION_MAP();" :title="$t('Pilot.MissionDrawer.HideAllListedMissionTooltip')" ><v-icon>mdi-eye</v-icon></v-btn>  
     </div> -->
     <h2 class="py-2 ml-4" v-if="coverageIteration" > {{ missionGlobal.MIG_LIBELLE }} #{{ coverageIteration.COV_ITERATION }}</h2>
     <h2 class="py-2 ml-4" v-else > {{ missionGlobal.MIG_LIBELLE }} {{ $t("Simulation.Current") }}</h2>
   </div>
   <div class="!grow-0 flex flex-col pa-2 text-xs" style="background-color: #eee;">      
 
      <table class="mrs-tbl" cellspacing="0">
          <thead>
            <tr>          
              <td>{{$t("Simulation.ProcessingStep")}}</td>
              <td>{{$t("Simulation.ProcessingState")}}</td>
              <td v-if="covState == 'running'">{{$t("Simulation.EstimatedEndDate")}}</td>
              <!-- <td>{{$t("Simulation.ProcessingTime")}}</td>
              <td>{{$t("Simulation.EstimatedMissionEndDate")}}</td>                          -->
            </tr>
          </thead>
          <tr  v-if="coverageIteration">
              <td><span class="data">{{$t(coverageStepTradKey) }}</span></td>
              <td><span class="data">{{$t(coverageStateTradKey) }}</span></td>    
              <td v-if="covState == 'running'">
                <CoveragEndIn :coverage-iteration="coverageIteration" />          
              </td>      
              <!-- <td>
                <span class="data" v-if="coverageIteration.processing_time">{{  $options.filters.formatDuration(coverageIteration.result.processing_time * 1000,true) }}</span>
              </td>
              <td>
                <span class="data" v-if="coverageIteration && coverageIteration.result">{{ $options.filters.formatDate(coverageIteration.result.mission_end_date,"DD/MM/YYYY HH:mm") }}</span>
              </td> -->
            </tr>
        </table>            
   </div>      
   <div class="grow flex" style="position:relative" >      
       <div ref="liste" class="drawer-container flex flex-col " :style="{overflow:coverageIterations.length <= 24?'auto':'none'}">
         <!-- Zone liste de résultats -->                                    
         <auto-virtual-scroll-list        
              v-if="coverageIterations.length > 24"  
             v-resize="onResize" :totalHeight="height"
             :defaultHeight="36"
             :extra-items="5"
             style="width: 100%;">    
                <CoverageCurrentLine />
               <CoverageIterationLine v-for="coverage in coverageIterations"  :key="coverage.id" :uiid="buildCoverageIterationUiStateId(coverage.id)" :coverage-iteration="coverage" />
           </auto-virtual-scroll-list>
           <div v-else >
             <CoverageCurrentLine />
             <CoverageIterationLine v-for="coverage in coverageIterations" :key="coverage.id" :uiid="buildCoverageIterationUiStateId(coverage.id)" :coverage-iteration="coverage" />
           </div>                  
       </div>    
       <!-- <div v-else class="flex items-center justify-center !grow">
         {{$t('Simulation.NoSimulation')}} <br/>
       </div>        -->
   </div> 
 </v-layout> 
</template>
<script lang="ts">

import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import CoverageIterationLine from '@/components/smart/Coverage/CoverageIterationLine.vue'
import CoverageCurrentLine from '@/components/smart/Coverage/CoverageCurrentLine.vue'
import  CoveragEndIn  from '@/components/smart/Coverage/CoveragEndIn.vue'

import Vue from 'vue'
import Component from 'vue-class-component'
import {buildCoverageIterationUiStateId} from '@/models/ui/CoverageIterationUiState'  
import { MapUiState } from '@/models/ui/MapUiState'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import {getCoverageState, getCoverageStateTradKey} from '@/enum/CoverageState'
import {getCoverageStep, getCoverageStepTradKey} from '@/enum/CoverageStep'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'


@Component({
name: 'CoverageDetailDrawer',
components:{CoverageIterationLine,CoverageCurrentLine,CoveragEndIn }
})
export default class CoverageDetailDrawer extends Vue {      
 
 
 showEditMissionGlobal = false  
 missionDetailLoading = -1
 
 get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }

  get coverage_uiid() {
    return buildCoverageStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get coverageState() {     
    return this.$store.myGetters.coverageStateByUiid(this.coverage_uiid)
  }

 get coverageIterationsById(){
   return this.$store.myGetters.coverageIterationsById
 }

 get coverageIteration() {
   return this.coverageState.selectedCoverageId?this.coverageIterationsById[this.coverageState.selectedCoverageId]:null
 }

 get coverageStepTradKey(){
    return getCoverageStepTradKey(getCoverageStep(this.coverageIteration?.COV_PROCESSING_STEP))
 }

 get covState(){
    return getCoverageState(this.coverageIteration?.COV_PROCESSING_STATE)
 }

 get coverageStateTradKey(){
    return getCoverageStateTradKey(this.covState)
 }
 
 get isRunnable()
 {
   return true
 }

 get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

 get coverageIterations(){
   return this.$store.myGetters.coverageIterations?.filter(c=> !!c && c.MIG_ID == this.missionGlobal.MIG_ID).sort((s1,s2)=>s2.id! - s1.id!)
 }

 height = 100

 buildCoverageIterationUiStateId(covId:number, typeUiid="detail") {
   return buildCoverageIterationUiStateId(covId,typeUiid)
 }

 mounted(){
   this.onResize()
 }

 onResize() {
   //@ts-ignore
   if(this.$refs.liste) this.height = this.$refs.liste.clientHeight        
 }
 
}
</script> 

<style scope>  
 .header-list{
   flex: 0 0 auto;
 }
 .filter{
   flex: 0 0 auto;    
   height: min-content;
   background-color: #eee;
 }
.liste {
   flex: 1 1 auto;
   overflow: hidden;
   height: min-content;
 }  
</style>